/**
 * `nav` namespace — English canonical source.
 *
 * Drives the app chrome: the sidebar rail (section labels), the operator footer,
 * and the ambient arm-state module. Section labels follow the product glossary
 * (Dashboard/Portfolio/Strategy/Orders/Approvals/Notifications/Settings). The
 * arm-state strings are the *explanatory* labels only — the compact status badges
 * themselves ("ARMED"/"DISARMED"/"DRY-RUN") stay English and are not sourced here.
 * `ko/nav.ts` mirrors this shape (a missing key is a type error).
 */
export const nav = {
  // ── rail sections ──
  dashboard: "Dashboard",
  portfolio: "Portfolio",
  market: "Market",
  strategies: "Strategies",
  chat: "Chat",
  orders: "Orders",
  approvals: "Approvals",
  notifications: "Notifications",
  settings: "Settings",

  // ── operator footer ──
  owner: "Owner",
  signOut: "Sign out",
  setupRequired: "Setup required",
  switchToLight: "Switch to light mode",
  switchToDark: "Switch to dark mode",
  toggleTheme: "Toggle theme",

  // ── arm-state module (explanatory labels; badges stay English) ──
  tradingArmed: "Trading armed",
  disarmed: "Disarmed",
  liveOrders: "New-strategy default · live",
  dryRunSimulated: "New-strategy default · dry-run",
} as const;

export type NavKey = keyof typeof nav;
